import { useNavigate } from "react-router-dom";

function newSessionId() {
  return `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export default function PersonaFork() {
  const navigate = useNavigate();

  const pick = (mode) => {
    const id = newSessionId();
    // pass mode via url query
    navigate(`/chat/${id}?mode=${mode}`);
  };

  return (
    <div className="flex flex-col min-h-[100dvh] px-8 pt-20 pt-safe pb-12 pb-safe">
      <button
        data-testid="back-home"
        onClick={() => navigate("/")}
        className="relative z-10 -m-3 p-3 self-start text-still-muted text-sm hover:text-still-fg transition-colors"
        aria-label="Back"
      >
        ← Back
      </button>

      <div className="mt-16">
        <p className="text-xs uppercase tracking-[0.3em] text-still-muted">Before we start</p>
        <h2 className="font-serif text-4xl sm:text-5xl font-light mt-4 leading-[1.1] text-still-fg">
          How can I be with you<br />right now?
        </h2>
      </div>

      <div className="mt-auto flex flex-col gap-4">
        <button
          data-testid="mode-vent"
          onClick={() => pick("vent")}
          className="group relative overflow-hidden rounded-3xl border border-still-border bg-still-surface py-8 px-6 text-left transition-colors hover:bg-[#26221F]"
        >
          <div
            className="absolute inset-0 opacity-40 pointer-events-none"
            style={{
              background:
                "linear-gradient(135deg, rgba(199,125,99,0.22) 0%, rgba(30,28,26,0) 60%)",
            }}
          />
          <div className="relative">
            <div className="font-serif text-2xl italic text-still-fg">Just need to vent</div>
            <div className="text-still-muted text-sm mt-2 leading-relaxed">
              I&apos;ll listen. No advice unless you ask.
            </div>
          </div>
        </button>

        <button
          data-testid="mode-figure"
          onClick={() => pick("figure")}
          className="group relative overflow-hidden rounded-3xl border border-still-border bg-still-surface py-8 px-6 text-left transition-colors hover:bg-[#26221F]"
        >
          <div
            className="absolute inset-0 opacity-40 pointer-events-none"
            style={{
              background:
                "linear-gradient(135deg, rgba(131,147,123,0.22) 0%, rgba(30,28,26,0) 60%)",
            }}
          />
          <div className="relative">
            <div className="font-serif text-2xl italic text-still-fg">
              Help me figure something out
            </div>
            <div className="text-still-muted text-sm mt-2 leading-relaxed">
              We&apos;ll sit with it, then think it through together.
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}
